// @ts-nocheck
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ContestLeaderboard = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 text-white py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl font-bold mb-8 text-center">🏆 Contest Leaderboard</h1>

        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-12 text-center">
          <div className="text-6xl mb-6">📊</div>
          <h2 className="text-3xl font-bold mb-4">Coming Soon!</h2>
          <p className="text-xl text-gray-300 mb-8">
            The leaderboard will be available once submissions start rolling in.
          </p>
          <p className="text-lg text-gray-400 mb-8">
            Check back after the first submissions are reviewed!
          </p>
          <button
            onClick={() => navigate('/contest')}
            className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-xl font-bold hover:from-blue-600 hover:to-purple-600 transition-colors"
          >
            ← Back to Contest
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContestLeaderboard;
